export const HOME_COPY = {
  banner: {
    welcome: 'Te damos la bienvenida al portal de microempresarios',
  },
  ctaBar: {
    subtitle:
      'Completa tu perfil para desbloquear ofertas de crédito personalizadas de nuestros aliados financieros.',
    solicitarCredito: 'Solicitar crédito',
  },
  solicitudes: {
    title: 'Tus solicitudes de crédito',
    subtitle: 'Historial y estado de cada solicitud con bancos aliados',
    empty: 'Aún no tienes solicitudes de crédito.',
    columnas: {
      solicitud: 'Solicitud',
      monto: 'Monto solicitado',
      fecha: 'Fecha de creación',
      estado: 'Estado',
      acciones: 'Acciones',
    },
    verDetalle: 'Ver detalle',
    eliminarAria: 'Cancelar solicitud',
    tooltipId: 'Aquí podrás ver los detalles de tu solicitud de crédito',
    explorarOportunidades: 'Explorar oportunidades',
    sinCobertura: 'Ver información',
  },
  modalEnviarRecordatorio: {
    titulo: '¡No olvides enviar tu solicitud!',
    ctaRevisar: 'Revisar información',
    ctaEnviar: 'Enviar solicitud',
    ctaEnviando: 'Enviando…',
  },
  modalCancelarSolicitud: {
    titulo: 'Cancelar la solicitud',
    tituloConfirm: '¿Desea cancelar solicitud?',
    numeroLabel: 'Número de solicitud:',
    observacionLabel: 'Observación',
    observacionError: 'Campo obligatorio*',
    ctaSalir: 'Salir',
    ctaCancelar: 'Cancelar solicitud',
    ctaConfirmar: 'Confirmar',
    ctaConfirmando: 'Confirmando…',
  },
  modalInfoEstado: {
    ctaSalir: 'Salir',
    ctaFinalizar: 'Finalizar',
    ctaFinalizando: 'Finalizando…',
    sinCobertura: {
      titulo: 'Tu solicitud se encuentra sin cobertura',
      mensaje:
        'Actualmente no tenemos Aliados Financieros que puedan atender tu solicitud. Muy pronto nos comunicaremos contigo para indicarte los pasos a seguir.',
    },
    sinOfertas: {
      titulo: 'Tu solicitud no ha recibido propuestas',
      mensaje:
        'Actualmente no tenemos ofertas de crédito para ti. Te invitamos a ingresar a los siguientes cursos que te apoyarán en tu crecimiento empresarial.',
      cursoLabel: 'Accede a los cursos',
      cursoHref:
        'https://campusvirtual.bancoldex.com/mod/page/view.php?id=5793',
    },
  },
} as const;
